import React from 'react'

export default class ResultItem extends React.Component {
  render() {
    return (
      <tr>
        <td>{this.props.categoryname}</td>
        <td>{this.props.name}</td>
        <td>{this.props.added}</td>
        <td>{this.props.size}</td>
        <td>{this.props.completed}</td>
        <td>{this.props.seeders}</td>
        <td>{this.props.leechers}</td>
      </tr>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/search/ResultItem.js